  $(document).ready(function () {
        $('.faq__item').click(function (){ 
      if($(this).hasClass('active')){
         $('.faq__item').removeClass("active");
         $('.faq__answer').slideUp();
      }else{
         $('.faq__item').removeClass("active");
         $('.faq__answer').slideUp();
         $(this).find('.faq__answer').slideDown();
         $(this).addClass('active');
      }
    });

    $("#openPopup").click(function() {
        $("#popup").fadeIn();
    });

    $(".close").click(function() {
        $("#popup").fadeOut();
        var city = $('.popup_fields #citystate').val().trim();
        var name = $('.popup_fields #nameshulkollel').val().trim();
        var rosh = $('.popup_fields #chaburahrav').val().trim();
        var p_qty = parseInt($('.product quantity-input input.quantity__input').val());
        if(city != '' && name != '' && rosh != '' && p_qty >= 5){
          $('.popup_append_fields').html($('.popup_fields').html());
          $('.popup_append_fields #citystate').val(city);
          $('.popup_append_fields #nameshulkollel').val(name);
          $('.popup_append_fields #chaburahrav').val(rosh);
          $('.popup_coupon').removeClass("hidden");
      
          console.log(city);
          console.log(name);
          console.log(rosh);
        }else{
          $('.popup_append_fields').html("");
          $('.popup_coupon').addClass("hidden");  
        }
    });
$('.popup_btn_submit').click(function (params) {
  $('.popup-content .close').trigger('click');
})
    $(window).click(function(event) {
        if ($(event.target).is("#popup")) {
            $("#popup").fadeOut();
        }
    });

// var abc = $('#city-and-state').val().trim();
// var abc = $('#name-of-shulkollel').val().trim();
// var abc = $('#rosh-chaburahrav').val().trim();
  });